<template>
    <div :class="[$style.UIChanges, changesClasses]">
        <WBIcon class="change-position__icon" name="change-position" />
        <span>{{ changesNumber }}</span>
    </div>
</template>

<script setup lang="ts">
    interface Props {
        value: number | undefined
    }

    const props = withDefaults(defineProps<Props>(), {
        value: 0,
    })
    const $style = useCssModule()
    const changesNumber = computed<string>(() => {
        let result = props.value
        if (Math.abs(props.value) >= 10000) {
            result = `${(props.value / 1000).toFixed(1)}k`
        }
        if (props.value >= 0) {
            return `${String(result).replace('+', '')}`
        } else {
            return `${String(result).replace('-', '')}`
        }
    })

    const changesClasses = computed(() => {
        if (props.value >= 0) {
            return $style._positive
        } else {
            return $style._negative
        }
    })
</script>

<style lang="scss" module>
    .UIChanges {
        display: flex;
        align-items: center;
        width: max-content;
        min-width: 40px;
        height: 100%;
        max-height: 18px;
        padding: 2px 11px;
        border-radius: 13px;

        span{
            display: inline-block;
            margin-left: 2px;
            font-family: var(--accent-font);
            font-size: 10px;
            font-weight: 600;
            line-height: 1;
        }

        svg{
            width: 10px;
        }

        &._positive {
            background-color: var(--green-300);
            color: var(--green-800);
        }

        &._negative {
            background-color: var(--red-300);
            color: var(--red-600);

            svg{transform: rotate(180deg);}
        }
    }
</style>
